export default function debounce  (fn, ms)  {
    let timer;
    return (_) => {
        clearTimeout(timer);
        timer = setTimeout((_) => {
            timer = null;
            // eslint-disable-next-line no-undef
            fn.apply(this, arguments);
        }, ms);
    };
}